import { posthog } from '../../../../initializers/posthog';

// FLA-8199. Two things had to be true at once: we need to know whether the
// assistant is any good, AND we must be able to see what went wrong — without
// shipping HR chat content to an analytics vendor.
//
// So nothing here is content. Not the question, not the answer, not a name, an
// amount or a date. What ships is the SHAPE of the answer that was rated:
// which tools ran, whether a widget and a next-step link rendered, how long the
// reply was, and which turn of the conversation it was. That is enough to see
// "downvotes cluster on policy answers with no widget" or "on turn 4+", which
// is what actually gets a bug filed.
//
// `runId` is the server's own opaque trace id. It carries no personal data and
// is the join key: once the server-side trace store lands, a 👎 here can be
// opened as the (anonymised) transcript there. PostHog identity is the hub user,
// as with every other event in the app — "anonymous" here means content-free.
export type AiChatFeedbackEvent = {
  rating: 'up' | 'down';
  runId: string;
  tools: string[];
  hadWidget: boolean;
  hadNextStep: boolean;
  answerLength: number;
  turn: number;
};

export function captureAiChatFeedback(event: AiChatFeedbackEvent): void {
  posthog.capture('ai_chat_feedback', {
    rating: event.rating,
    run_id: event.runId,
    tools: event.tools,
    tool_count: event.tools.length,
    had_widget: event.hadWidget,
    had_next_step: event.hadNextStep,
    // Bucketed, not exact: a length is a weak fingerprint of the content.
    answer_length_bucket: lengthBucket(event.answerLength),
    turn: event.turn,
  });
}

function lengthBucket(length: number): string {
  if (length === 0) return 'empty';
  if (length < 200) return 'short';
  if (length < 800) return 'medium';
  return 'long';
}
